var React = require('react');

function Upload (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M16.125 8.36666C15.5583 5.49166 13.0333 3.33333 10 3.33333C7.59167 3.33333 5.5 4.69999 4.45833 6.69999C1.95 6.96666 0 9.09166 0 11.6667C0 14.425 2.24167 16.6667 5 16.6667H15.8333C18.1333 16.6667 20 14.8 20 12.5C20 10.3 18.2917 8.51666 16.125 8.36666ZM11.6667 10.8333V14.1667H8.33333V10.8333H5.83333L10 6.66666L14.1667 10.8333H11.6667Z","fill":"#FEFEFE"}));
}

Upload.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = Upload;

Upload.default = Upload;
